export default __webpack_public_path__ + "static/media/Rectangle2.644104c0.jpg";